import React from 'react'
import { Svg } from 'ui'
import { Flex, Text } from 'theme-ui'
import FeatureIs from 'images/onboard/feature-is-icon.svg'
import FeatureIsNot from 'images/onboard/feature-is-not-icon.svg'
import { CONTROLDText } from 'ui/CONTROLD'

const whatControlDIsFeatures = [
  'Cloud based DNS security and productivity platform',
  'Tool that blocks malware and unwanted content (ads)',
  'Service that improves privacy and spoofs your IP',
]

const whatControlDIsNotFeatures = [
  "Dedicated geo-unblocking service. Don't sign up if this is your sole use case.",
  'A VPN. Control D can spoof your IP, but will not bypass government restrictions.',
]

export const inputStyles = {
  height: ['4.8rem', '4.7rem'],
  alignSelf: 'end',
  borderRadius: '1.2rem',
  background: 'blueYonder10',
  p: '1.6rem',
  fontSize: '1.5rem',
  color: 'aliceBlue',
  '& + div': {
    ml: 0,
    '& > label': {
      color: 'aliceBlue',
      opacity: 0.7,
      fontSize: '1.5rem',
      fontWeight: 400,
    },
  },
}

export default function WhatControlDIsOrIsNot(): React.ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        maxWidth: ['100%', '44rem', '44rem'],
        flexDirection: 'column',
        flexShrink: [1, 1, 0],
        height: 'fit-content',
        gap: '3.2rem',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.2rem',
        }}
      >
        <Text variant="size17Weight700Line138" sx={{ mb: '1.6rem' }}>
          What {CONTROLDText} is
        </Text>
        {whatControlDIsFeatures.map((feature, index) => (
          <Flex
            key={feature}
            sx={{
              width: '100%',
              p: '1.6rem 0.8rem',
              borderTop: index && '0.1rem solid',
              borderColor: 'white10',
              textAlign: 'left',
              alignItems: 'center',
              gap: '1.6rem',
            }}
          >
            <Svg svg={FeatureIs} sx={{ flexShrink: 0 }} descriptiveText="Feature included" />
            <Text variant="size14Weight400Line138" sx={{ color: 'aliceBlue' }}>
              {feature}
            </Text>
          </Flex>
        ))}
      </Flex>
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.2rem',
        }}
      >
        <Text variant="size17Weight700Line138" sx={{ mb: '1.6rem' }}>
          What {CONTROLDText} is not
        </Text>
        {whatControlDIsNotFeatures.map((feature, index) => (
          <Flex
            key={feature}
            sx={{
              width: '100%',
              borderTop: index && '0.1rem solid',
              borderColor: 'white10',
              p: '1.6rem 0.8rem',
              textAlign: 'left',
              alignItems: 'center',
              gap: '1.6rem',
            }}
          >
            <Svg svg={FeatureIsNot} sx={{ flexShrink: 0 }} descriptiveText="Feature not included" />
            <Text variant="size14Weight400Line138" sx={{ color: 'aliceBlue' }}>
              {feature}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}
